import { Form } from 'factorial-form'

class DurationRuleForm extends Form {
  static defaultValues = {
    periodLength: null,
    minimalDuration: null,
    _destroy: false,
  }

  constructor(values: Record<string, any> = {}) {
    const normalizedValues = {
      periodLength: values.periodLength / 100,
    }
    super(
      { ...DurationRuleForm.defaultValues, ...values, ...normalizedValues },
      {
        id: 'string',
        periodLength: 'string',
        minimalDuration: 'string',
        _destroy: 'boolean',
      }
    )
  }

  get isValid(): boolean {
    return +this.get('periodLength').value > 0 && +this.get('minimalDuration').value > 0
  }

  data() {
    return {
      ...super.data(),
      periodLength: Math.round(this.get('periodLength').value * 100),
      _destroy: this.get('_destroy').value || !this.isValid,
    }
  }
}

export default DurationRuleForm
